import { getCookie } from 'lib/cookies'
import { ConstructorResultsDataGroupObject, GetAspectRatioParams } from '../../constructorTypes'

const CONSTRUCTOR_INDEX_COOKIE = 'constructor_prod_index'

export const getConstructorIndex = (): string => {
  const { CONSTRUCTOR_QA_API_KEY, CONSTRUCTOR_PRODUCTION_API_KEY, APP_ENV } = process.env

  const isProductionEnvironment = APP_ENV === 'production'
  const constructorCookieValue = getCookie({ name: CONSTRUCTOR_INDEX_COOKIE }) || ''
  const shouldUseProductionIndex = constructorCookieValue === '1'
  const constructorIndex =
    shouldUseProductionIndex || isProductionEnvironment
      ? CONSTRUCTOR_PRODUCTION_API_KEY
      : CONSTRUCTOR_QA_API_KEY

  return constructorIndex || ''
}

export const getCategoryFromGroups = (
  groups: ReadonlyArray<ConstructorResultsDataGroupObject>
): string => {
  const categoryArray = groups
    ?.map(({ display_name }) => display_name)
    ?.filter((categoryName) => !['all', 'prints'].includes(categoryName?.toLowerCase()))
  return categoryArray?.[0]
}

export const getAspectRatio = ({
  isPrintsPage,
  aspectRatio = 1,
  printAspectRatio = 1,
}: GetAspectRatioParams): number => {
  return isPrintsPage ? printAspectRatio : aspectRatio
}
